import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  max-height: ${props => (props.$isOpen ? pxToRem(80) : 0)};
  transition: max-height 200ms ease-in-out;
  overflow: hidden;
`;
